import { render, staticRenderFns } from "./AdminPendingVolunteers.vue?vue&type=template&id=3032fdeb&scoped=true&"
import script from "./AdminPendingVolunteers.vue?vue&type=script&lang=js&"
export * from "./AdminPendingVolunteers.vue?vue&type=script&lang=js&"
import style0 from "./AdminPendingVolunteers.vue?vue&type=style&index=0&id=3032fdeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3032fdeb",
  null
  
)

export default component.exports